// src/static/js/flashConfig.js

/**
 * Конфигурация слоёв flash-подсветки
 */
export const flashLayerConfig = {
    glow: {
        id: 'flash-glow-layer',
        paint: {
            'line-color': '#FFD700',
            'line-width': 14,
            'line-blur': 6,
            'line-opacity': 0.45,
        }
    },
    outline: {
        id: 'flash-outline-layer',
        paint: {
            'line-color': '#FFD700',
            'line-width': 3,
            'line-blur': 0,
            'line-opacity': 1,
        }
    }
};

